<template>
  <div>
    <van-popup
      v-model="isShow"
      class="sub-popup"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <div class="intention_wrap">
        <img
          class="icon_close"
          src="@/assets/img/activity/icon_close.png"
          alt=""
          @click="closePop()"
        />
        <div class="intention_tip">添加求职意向后才可以关注</div>
        <div class="follow_tip">关注后职位有更新会及时通知你</div>
        <div class="sub_btn" @click="openIntention()">去填写</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import wx from "weixin-js-sdk";
import { Popup } from "vant";
export default {
  name: "IntentionPop",
  components: {
    [Popup.name]: Popup,
  },
  props: {
    intentionPopVisible: {
      type: Boolean,
      default: false,
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["commonStore"]),
    isShow: {
      get() {
        if (this.intentionPopVisible) {
          this.$sensors.track("PopupShow", {
            popupId: "sensor_bcop_intentionrefinepopup",
            groupId: this.pageConfig.activityZoneId,
            contentName: this.pageConfig.activityZoneTitle,
            workIntegrityFunc: this.commonStore.intention.expectFunction,
          });
        }
        return this.intentionPopVisible;
      },
      set() {},
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isApp() {
      return (
        this.$store.getters.platform === "51jobApp" ||
        this.$store.getters.platform === "yjsApp"
      );
    },
    isWeChat() {
      return this.$store.getters.appType === "weixin";
    },
    platform() {
      return this.$store.getters.platform;
    },
    isMiniProgram() {
      return (
        this.$store.getters.platform === "51jobWX" ||
        this.$store.getters.platform === "yjsWX"
      );
    },
  },
  data() {
    return {};
  },
  methods: {
    openIntention() {
      this.$sensors.track("PopupClick", {
        popupId: "sensor_bcop_intentionrefinepopup",
        groupId: this.pageConfig.activityZoneId,
        contentName: this.pageConfig.activityZoneTitle,
        workIntegrityFunc: this.commonStore.intention.expectFunction,
      });
      if (this.isWeChat) {
        //微信
        document.addEventListener("visibilitychange", this.visibilitychange);
        let url = "/pages/resume/intention/edit";
        this.$wx.miniProgram.navigateTo({ url });
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_qzyx_yd",
        });
      } else if (this.platform.includes("yjs")) {
        this.$base.watchAppCover(this.refreshIntention);
        window.location.href = "yingjiesheng://home/openJobIntentionPage";
      } else if (this.platform.includes("51job")) {
        this.$base.watchAppCover(this.refreshIntention);

        if (this.$store.getters.device == "harmonyApp") {
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "qiancheng://home/show_job_intention_edit"
          }));
        } else {
          window.location.href = "qiancheng://home/show_job_intention_edit";
        }
      } else {
        console.log(this.platform);
      }
      this.closePop();
    },
    refreshIntention() {
      //刷新求职意向接口
      console.log("刷新求职意向接口");
      this.$base.getIntention();
    },
    closePop() {
      this.$emit("update:intentionPopVisible", false);
    },
  },
};
</script>

<style lang="less" scoped>
.sub-popup::before {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  content: "";
  height: 181px;
  width: 311px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("@/assets/img/activity/tipPopBg.png");
}
.sub-popup {
  position: fixed;
  overflow-y: visible;
  width: 311px;
  background: linear-gradient(180deg, #fffce1 0%, #ffffff 50%);
  border-radius: 16px;
  text-align: center;
  font-style: normal;
  border-radius: 16px;
  opacity: 1;
  background: #ffffff;
  .icon_close {
    position: absolute;
    top: 10px;
    left: 16px;
    width: 18px;
    height: 18px;
  }

  .intention_wrap {
    position: relative;
    z-index: 2;
    padding-top: 131px;
  }
  .intention_tip {
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    color: #000000;
  }
  .follow_tip {
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    color: #666666;
    margin: 6px 0 24px;
  }
  .sub_btn {
    width: 200px;
    height: 44px;
    line-height: 44px;
    margin: 0 auto 32px;
    border-radius: 22px;
    opacity: 1;
    background: linear-gradient(180deg, #ffb240 2%, #ff6300 100%);
    box-sizing: border-box;
    border: 1px solid #ffe7ce;
    box-shadow: inset 0px 3px 9px 0px #ff6906;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
  }
}
</style>
